export default __webpack_public_path__ + "static/media/india_delgado.006d4eb4.png";